"use client"

import { useEffect } from "react"
import { AlertTriangle } from "lucide-react"
import { Button } from "@/components/ui/button"
import { logError } from "@/lib/log-error"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    logError({
      level: "error",
      source: "error-boundary",
      message: error.message || "Unknown error",
      stack: error.stack,
      extra: error.digest ? { digest: error.digest } : undefined,
    })
  }, [error])

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] gap-4 p-6 text-center">
      <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center">
        <AlertTriangle className="size-7 text-red-500" />
      </div>
      <div>
        <h2 className="text-lg font-semibold text-gray-900">Une erreur est survenue</h2>
        <p className="text-sm text-gray-500 mt-1 max-w-md">
          L'erreur a ete signalée automatiquement. Vous pouvez reessayer ou revenir a l'accueil.
        </p>
        {error.digest && (
          <p className="text-xs text-gray-400 mt-2 font-mono">Ref: {error.digest}</p>
        )}
      </div>
      <div className="flex gap-3">
        <Button onClick={reset} variant="outline" size="sm">
          Reessayer
        </Button>
        <Button onClick={() => (window.location.href = "/")} size="sm">
          Accueil
        </Button>
      </div>
    </div>
  )
}
